<template>
  <div class="row" id="gauges-row" v-if="performance && availablity && quality">
    <div class="col-12">

      <BarChart style=" width: 100%; height: 100%"
                :chartData="getOEEChartData"
                :options="getOptions({title:'OEE ' + getChartTitle})"/>
    </div>

  </div>
  <ComponentLoadSpinnerV2 v-else :loading="true"/>
</template>

<script>
import BarChart from "@/components/oeeAnalytics/charts/barChart";
import ComponentLoadSpinnerV2 from "@/components/general/ComponentLoadSpinnerV2";
import oeeCalculations from "@/mixins/oeeAnalytics/oeeCalculations";
import {mapGetters} from "vuex";
import colours from "@/mixins/oeeAnalytics/colours";

export default {
  name: "OEEEBarchartsDaily",
  props: ['availablity', 'performance','quality'],
  mixins: [oeeCalculations, colours],
  components: {
    BarChart,
    ComponentLoadSpinnerV2
  },
  computed: {
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getUnit', 'getDateRange']),
    getChartTitle() {
      return moment(this.getSelectedDate).format('DD-MM-YYYY');
    },
    getOEEChartData() {
      let rangeToUse = _.cloneDeep(this.getDateRange);
      let unitToUse = null;

      if (this.getSelectedDate) {
        rangeToUse.fromDate = moment(this.getSelectedDate).startOf(this.getUnit === 'week' ? 'isoWeek' : this.getUnit).toDate();
        rangeToUse.toDate = moment(this.getSelectedDate).endOf(this.getUnit === 'week' ? 'isoWeek' : this.getUnit).toDate();
        unitToUse = _.cloneDeep(this.getUnit);
      }

      const oeeData = this.getOeeDataPerDateUnit(this.availablity, this.performance,this.quality, rangeToUse.fromDate, rangeToUse.toDate, unitToUse);
      let averageOee = _.meanBy(oeeData, 'oee');

      const performanceData = this.getPerformanceDataPerDateUnit(this.performance, rangeToUse.fromDate, rangeToUse.toDate, unitToUse);
      let averagePerformance = _.meanBy(performanceData, 'performance');

      const availabilityData = this.getAvailabilityDataPerDateUnit(this.availablity, rangeToUse.fromDate, rangeToUse.toDate, unitToUse);

      let averageAvailability = _.meanBy(availabilityData, 'availability');
      const qualityData = this.getQualityPerDateUnit(this.quality, rangeToUse.fromDate, rangeToUse.toDate, unitToUse);
       let averageQualityData =_.meanBy(qualityData, 'quality');
       return {
        labels: [this.$t('oeeAnalytics.oeeCharts.gauges.oee'), this.$t('oeeAnalytics.oeeCharts.gauges.quality'), this.$t('oeeAnalytics.oeeCharts.gauges.performance'), this.$t('oeeAnalytics.oeeCharts.gauges.availability')].reverse(),
        datasets: [
          {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.availability'),
            data: [0, 0, 0, _.round(averageAvailability * 100, 0)].reverse(),
            backgroundColor: this.getOeeColours('availability'),
            hoverOffset: 4
          },
          {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.performance'),
            data: [0, 0, _.round(averagePerformance * 100, 0), 0].reverse(),
            backgroundColor: this.getOeeColours('performance'),
            hoverOffset: 4
          },
          {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.quality'),
            data: [0, _.round(averageQualityData * 100, 0), 0, 0].reverse(),
            backgroundColor: this.getOeeColours('quality'),
            hoverOffset: 4
          },
          {
            label: this.$t('oeeAnalytics.oeeCharts.gauges.oee'),
            data: [_.round(averageOee * 100, 0), 0, 0, 0].reverse(),
            backgroundColor: this.getOeeColours('oee'),
            hoverOffset: 4
          }
        ]
      };
    },
    getDefaultOptions() {
      const self = this
      return {
        animation: {
          duration: 0 // general animation time
        },
        hover: {
          animationDuration: 100,
          intersect:false,// duration of animations when hovering an item
        },
        legend: {
          display: false,
        },

        title: {
          display: true,
          text: 'Dag',
          fontSize: 108,
          fontStyle: 'normal',
          position: 'bottom',
        },
        scales: {
          xAxes: [{
            stacked: true,
            reverse: true,
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            stacked: true,
            reverse: true,
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true,
              // Include a % sign in the ticks
              callback: function (value, index, ticks) {
                return value + '%';
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            // title: function (tooltip) {
            //   return tooltip[0].label
            // },
            // label: function (tooltipItem) {
            //   return self.formattedColonTime(tooltipItem.value) + 'u'    //tooltipItem.value
            // }
          }
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return value > 0 ? value + '%' : '';
            },
            color: 'white',
            fontFamily: 'Open Sans',
            anchor: 'end',
            align: 'start',
            font: {
              weight: 'bold',
              size: 14

            },
            offset: 0,
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    },


    getChartData() {
      return this.getAvailabilityChartData
    }
  },
  methods: {
    getOptions(options) {
      if(options.title.includes('Invalid date')){
        options.title = 'OEE'
      }
      return {
        ...this.getDefaultOptions,
        title: {
          display: true,
          text:options.title,
          fontSize: 18,
          fontStyle: 'normal',
          position: 'bottom',
        }
      }
    },
  }
}
</script>

<style scoped>

</style>